.minorActionPrompt {
  border-radius: 8px;
  margin-top: 20px;
  border: 1px solid var(--ds-pearl-grey-darker);
  padding: 8px 4px;

  & .minorActionPromptTitle {
    margin-bottom: 12px;
  }

  & .actionChoice {
    cursor: pointer;
    &:hover {
      font-weight: 600;
    }

    &.justSayNo {
      margin-top: 20px;
    }
  }

  &.loading {
    pointer-events: none;
    opacity: 0.6;
  }
}
